import { Controller } from "@hotwired/stimulus"

import Inputmask from "inputmask"

// Connects to data-controller="mask"
export default class extends Controller {
  static targets = ['money', 'mask']

  connect() {
    Inputmask.extendAliases({
      reais: {
        prefix: "R$ ",
        groupSeparator: "",
        radixPoint: ',',
        alias: "numeric",
        placeholder: "0",
        autoGroup: !0,
        digits: 2,
        digitsOptional: !0,
        clearMaskOnLostFocus: !1
      }
    })

    Inputmask({
      alias: 'reais'
    }).mask(this.moneyTargets)

    this.maskTargets.forEach(target => {
      if (target.dataset.mask == "phone") {
        Inputmask("(99) 9{4,5}-9999").mask(target)
      } else {
        Inputmask(target.dataset.mask).mask(target)
      }
    })
  }
}
